import React from 'react';
import { Box, Typography } from '@mui/material';
import appConfig from '../config/appConfig';

const DEFAULT_TITLE = 'Developer Dashboard';
const DEFAULT_DESCRIPTION = 'The Developer Dashboard provides access to API keys, webhooks, and integration settings.';

const SubscriptionRequiredBanner = ({ title = DEFAULT_TITLE, description = DEFAULT_DESCRIPTION }) => {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: 520,
          backgroundColor: 'rgba(255,255,255,0.04)',
          borderRadius: 2,
          p: 4,
          boxShadow: '0 8px 30px rgba(0,0,0,0.4)',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          {title}
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
          {description}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            backgroundColor: 'rgba(255, 193, 7, 0.12)',
            borderRadius: 1,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              width: 4,
              backgroundColor: '#f5b000',
            }}
          />

          <Box sx={{ p: 2 }}>
            <Typography variant="body2">
              This feature is not included in your subscription. Please reach out to{' '}
              <Box component="span" sx={{ color: '#f5b000', fontWeight: 500 }}>
                {appConfig.brandEmail}
              </Box>{' '}
              to get access.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SubscriptionRequiredBanner;
